// make a context provider for amount selected by user like bankContext.jsx
import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const AmountSelectedContext = createContext();
const AmountSelectedContextProvider = ({ children }) => {
  const [amountSelected, setAmountSelected] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const contextValue = useMemo(() => ({
    amountSelected, setAmountSelected, paymentType, setPaymentType,
  }), [amountSelected, paymentType]);
  return (
    <AmountSelectedContext.Provider value={contextValue}>
      {children}
    </AmountSelectedContext.Provider>
  );
};
export default AmountSelectedContextProvider;
AmountSelectedContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
